// ============================================
// CONFIGURAZIONE UNIFICATA MODELLI AI
// ============================================
// Modifica QUI per cambiare i modelli usati in tutta l'applicazione

// Definizione di tutti i modelli Gemini disponibili con le loro caratteristiche
export const GEMINI_MODELS_CONFIG = [
  {
    name: 'gemini-3-flash-preview',
    version: 'v1beta',
    label: 'Gemini 3 Flash Preview',
    limits: '15 RPM / 1500 RPD',
    description: 'Versione più recente - preview'
  },
  {
    name: 'gemini-2.5-flash',
    version: 'v1beta',
    label: 'Gemini 2.5 Flash',
    limits: '4 RPM / 1500 RPD',
    description: 'Stabile - thinking mode'
  },
  {
    name: 'gemini-2.5-flash-lite',
    version: 'v1beta',
    label: 'Gemini 2.5 Flash Lite',
    limits: 'più alto RPM',
    description: 'Più veloce e leggero - low latency'
  }
];

// Configurazione per ogni contesto (quale modello usare)
export const AI_PROVIDER_CONFIG = {
  // Modello per bridge (analisi richiesta utente)
  // 2.5-flash-lite: più veloce, ottimizzato per low-latency
  bridge: {
    provider: 'gemini', // 'gemini' o 'deepseek'
    model: 'gemini-2.5-flash-lite' // Nome del modello da GEMINI_MODELS_CONFIG
  },

  // Modello per free text search (ricerca artisti)
  // 3-flash principale, 2.5-flash fallback
  freeTextSearch: {
    provider: 'gemini', // 'gemini' o 'deepseek'
    model: ['gemini-3-flash-preview', 'gemini-2.5-flash'] // Array = cascata
  },

  // Modello per similar artists/tracks
  similarArtists: {
    provider: 'gemini',
    model: 'gemini-3-flash-preview' // Singolo modello
  },

  // Modello per daily discovery (approfondimenti)
  dailyDiscovery: {
    provider: 'gemini', // 'gemini' o 'deepseek'
    model: 'gemini-3-flash-preview' // Singolo modello
  }
};

// Helper per ottenere la configurazione
export const getBridgeConfig = () => AI_PROVIDER_CONFIG.bridge;
export const getFreeTextSearchConfig = () => AI_PROVIDER_CONFIG.freeTextSearch;
export const getSimilarArtistsConfig = () => AI_PROVIDER_CONFIG.similarArtists;
export const getDailyDiscoveryConfig = () => AI_PROVIDER_CONFIG.dailyDiscovery;

// Helper per ottenere i modelli configurati per un contesto
// Restituisce array di oggetti modello con tutte le caratteristiche
export const getModelsForContext = (context) => {
  const config = AI_PROVIDER_CONFIG[context];
  if (!config) {
    console.warn(`[AI Config] Contesto sconosciuto: ${context}`);
    return [];
  }

  if (config.provider === 'deepseek') {
    // Per DeepSeek, crea modello dinamico
    const modelName = Array.isArray(config.model) ? config.model[0] : config.model;
    return [{ name: modelName, version: 'v1', label: `DeepSeek ${modelName}` }];
  }

  // Per Gemini, cerca i modelli in GEMINI_MODELS_CONFIG
  const modelNames = Array.isArray(config.model) ? config.model : [config.model];
  const models = modelNames
    .map(name => GEMINI_MODELS_CONFIG.find(m => m.name === name))
    .filter(m => m !== undefined); // Rimuovi modelli non trovati

  if (models.length === 0) {
    console.warn(`[AI Config] Nessun modello trovato per contesto ${context}, usando fallback`);
    return [GEMINI_MODELS_CONFIG[0]]; // Fallback al primo modello disponibile
  }

  return models;
};